/*/
	PRODUCT PAGE:
	Add Product to Cart
/*/

export function addToCart(selector) {
	var form = document.querySelector(selector);

	if (form) {
		var qtyBadge = document.querySelectorAll(".badge-quantity"),
			btn = form.querySelector('button[type="submit"]');

		form.addEventListener('submit', e => {
			e.preventDefault();

			btn.insertAdjacentHTML('beforeend', '<i class="fas fa-spinner fa-spin"></i>');

			var data = {
				'id': form.id.value,
				'quantity': form.quantity.value
			};

			fetch('/cart/add.js', {
				body: JSON.stringify(data),
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json',
					'X-Requested-With': 'xmlhttprequest'
				},
				method: 'POST'
			}).then(() => {
				fetch('/cart.js').then(res => res.json()).then(cart => {
					// Update Cart Badge Quantity
					qtyBadge.forEach(el => el.innerHTML = cart.item_count);

					btn.innerHTML = "Add to Cart";

					var rows = ``;

					cart.items.forEach(item => {
						rows = rows + `
							<tr>
								<th scope="row">${item.product_title}</th>
								<td>${item.variant_title}</td>
								<td align="right">${item.quantity}</td>
							</tr>`;
					});

					var table = `
						<p class="lead">Your cart now contains the following products:</p>

						<table class="table table-sm mb-0">
							<thead>
								<tr>
									<th scope="col">Product Name</th>
									<th scope="col">Variant</th>
									<th scope="col" class="text-right">Quantity</th>
								</tr>
							</thead>

							<tbody>
								${rows}
							</tbody>
						</table>
					`;

					$('#modal-cart').find('.modal-body').html(table);
					$('#modal-cart').modal('show');
				});
			}).catch(err => {
				console.error(err);
			});
		});
	}
}
